import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./BcsSwami.css";

const BcsSwamis = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="bcsSwami-wrapper">
            <div className="bcsSwami-hero">
                <div className="bcsSwami-text" data-aos="fade-right">
                    <h1>HH Bhakti Charu Swami Maharaja</h1>
                    <br /><h3>A Prabhupada Man</h3>
                </div>
            </div>
            <div className="bcsSwami-bio" data-aos="fade-up">
                <p>
                    <strong>His Holiness Bhakti Charu Swami </strong>  was born in Bengal in 1945, His Holiness Bhakti Charu Swami spent most of his early life in the city of Calcutta. In 1970, he left India to study in Germany. Coming across Vedic literatures while in Germany, he discovered the richness of India’s spiritual heritage. In 1975 he returned to India to wholeheartedly pursue the spiritual path.


                </p>
                <p>
                    After thoroughly studying the Vedic scriptures, His Holiness became aware of the need to find a spiritual master who could lead him on a sound spiritual course. After searching for one year without coming across a spiritual master to whom he could fully surrender, he felt despondent and disappointed. When he almost gave up his hope to find his spiritual master, he came across a book called The Nectar of Devotion by A.C. Bhaktivedanta Swami Prabhupada.


                </p>
                <p>
                    Becoming engrossed in the depths of that literature, he realized that he had found his spiritual master and the path for which he was searching. As he continued to read Srila Prabhupada’s works, his conviction grew stronger, as did his desire to meet Srila Prabhupada. At that time, Srila Prabhupada was in America. His Holiness joined the temple in Mayapur and became more involved in devotional service to the Lord, all the while awaiting Srila Prabhupada’s return to India.


                </p>
                <p>
                    When Srila Prabhupada returned to India at the end of 1976, the meeting between His Holiness Bhakti Charu Swami and Srila Prabhupada finally took place. From their very first meeting, Srila Prabhupada gave His Holiness the assignment of translating his books into Bengali and made him his Secretary for Indian Affairs. Within only a few months, Srila Prabhupada gave him initiation into the disciplic succession and soon thereafter, awarded him the order of Sannyasa.

                </p>
                <p>
                    Along side his official responsibilities, His Holiness translated all of Srila Prabhupada’s works on major Vedic literatures, consisting of more than fifty volumes of books, into Bengali, as Srila Prabhupada had instructed in their very first meeting. Subsequently, he became a member of the Governing Body Commission of the International Society for Krishna Consciousness and served as the Chairman of the Governing Body in 1989.


                </p>
                <p>In 1996, His Holiness took on the mammoth task of making a biographical video epic on the life of his spiritual master, A.C. Bhaktivedanta Swami Srila Prabhupada. This video series, entitled Abhay Charan has been seen all over the world, as well as on Indian National Television. At present His Holiness is currently developing projects in Ujjain, India. In February 2006, His Holiness constructed a beautiful temple in Ujjain. The temple has Five huge alters for the worship of Sri Sri Madan Mohan, Sri Sri Krishna Balaram, Sri Sri Gaura Nitai, Sri Sri Jagannath Baldeva Subhadra and Sri Sri Prahladesh Nrisimha Dev Ji.


                </p>
            </div>
        </div>
    );
};

export default BcsSwamis;
